/**
 * @file Defines constants for different game types.
 * @module gameTypes
 */

export const GAME_TYPE_QUICK_CLICK = 'QuickClickGame';
/**
 * Description placeholder
 *
 * @type {"CampaignClickGame"}
 */
export const GAME_TYPE_CAMPAIGN_CLICK = 'CampaignClickGame';
/**
 * Description placeholder
 *
 * @type {"CampaignRollingGame"}
 */
export const GAME_TYPE_CAMPAIGN_ROLLING = 'CampaignRollingGame';
/**
 * Description placeholder
 *
 * @type {"AutoSaveQuickGame"}
 */
export const GAME_TYPE_AUTOSAVE_QUICK = 'AutoSaveQuickGame';
/**
 * Description placeholder
 *
 * @type {"AutoSaveCampaignGame"}
 */
export const GAME_TYPE_AUTOSAVE_CAMPAIGN = 'AutoSaveCampaignGame';
/**
 * Description placeholder
 *
 * @type {"AutoSaveRollingGame"}
 */
export const GAME_TYPE_AUTOSAVE_ROLLING = 'AutoSaveRollingGame';
/**
 * Description placeholder
 *
 * @type {"MiniMergeGame"}
 */
export const GAME_TYPE_MINI_MERGE = 'MiniMergeGame';